import { render, staticRenderFns } from "./order-preview.vue?vue&type=template&id=5db34336&scoped=true"
import script from "./order-preview.vue?vue&type=script&lang=js"
export * from "./order-preview.vue?vue&type=script&lang=js"
import style0 from "./order-preview.vue?vue&type=style&index=0&id=5db34336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db34336",
  null
  
)

export default component.exports